module.exports = __webpack_public_path__ + "img/swap_active.a28ea50.webp";